"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const multipliers_1 = require("./multipliers");
/*
 * Returns the number of bytes based on multiples of bytes
 *
 * @Param {object} input = The byte multiple input
 *
 * @Example
 *
 *   bytes({ kB: 1})
 *   //=> 1000
 */
exports.bytes = (obj) => {
    const [[key, value]] = Object.entries(obj);
    return multipliers_1.MULTIPLIERS[key] * value;
};
//# sourceMappingURL=bytes.js.map